import React from "react";
import { Tooltip } from "antd";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import helpIconWhite from "../assets/images/DeathModuleNew/IC_Help_white.png";
import { tooltips } from "../constants/toolTips";

export const ToolTipCreator = ({ name , iconWhite = false}) => {
  const tooltip = tooltips.find((tip) => tip.name === name);

  if (!tooltip) return null; // don't render anything if tooltip not found

  return (
    <div>
      <Tooltip title={tooltip.tooltipText}>
        <img
          style={{
            cursor: "pointer",
            width: "25px",
            height: "25px",
          }}
          src={iconWhite ? helpIconWhite : helpIcon}
          alt="helpicon"
        />
      </Tooltip>
    </div>
  );
};
